module.exports = __webpack_public_path__ + "static/img/motor_256.54310a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/motor_256.png
// module id = R2v5
// module chunks = 0